import React, { Component } from 'react';
import {MasterLayout} from 'layout';
import {browserHistory} from 'react-router';

export default class LoadingThongBao extends Component {

  componentDidMount() {
    browserHistory.push(`/thanh-tra/chi-tiet-thong-bao/${this.props.params.id}`);
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className='wrap-loading'><img src={require('assets/images/blue_loading.gif')}/></div>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/LoadingThongBao.jsx